import { createMarkup } from '../utils/createMarkup.js';
import { FavoritesList } from './favorites/favoritesList.js';

try {
  const favoritesInStorage = localStorage.getItem('favorites');
  const favorites = favoritesInStorage ? JSON.parse(favoritesInStorage) : [];
  const favoritesList = new FavoritesList(favorites);
  favoritesList.init();
} catch (e) {
  const alertElement = createMarkup('div', {
    class: 'callout callout--error',
    role: 'alert'
  })
  alertElement.innerText = `Impossible de charger les favoris`;
  document.querySelector('[data-offcanvas="favorites"] .offcanvas__content').prepend(alertElement);

  // eslint-disable-next-line no-console
  console.error(e);
}
